import React from 'react';
import { FaStar } from 'react-icons/fa';
import HintTooltip from '@/components/HintTooltip';
import './SubscriberBadge.scss';

interface SubscriberBadgeProps {
  /** ISO timestamp of the subscription's first start. When present, the
   *  tooltip reads "Subscriber since {Month Year}"; otherwise it falls
   *  back to plain "Subscriber". */
  since?: string | null;
}

function formatSince(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleDateString(undefined, { month: 'short', year: 'numeric' });
}

/** Small inline "Subscriber" badge (#301). Reuses HintTooltip's
 *  hover/tap/mobile-friendly tooltip machinery — passes a star icon
 *  instead of the default ⓘ glyph. */
export const SubscriberBadge: React.FC<SubscriberBadgeProps> = ({ since }) => {
  const tooltip = since
    ? `Subscriber since ${formatSince(since)}`
    : 'Subscriber';

  return (
    <HintTooltip
      text={tooltip}
      placement="top"
      className="subscriber-badge"
      icon={<FaStar aria-hidden="true" />}
    />
  );
};

export default SubscriberBadge;
